// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1eYoO","overflowing":"ReadFullNote_overflowing__W8Z7P"};